
/**
 * Custom component for highlighted menu items with a containing box.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.3.0
 * @copyright  Copyright (C) 2024-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-03-23 (1.0.0) (jhoward)
 *      - <menu-item-highlighted-box> shows a menu item in an especially highlighting layout.
 *
 *    2024-12-16 (1.1.0) (jhoward)
 *      - Reorganize the <menu-item-highlighted-box> component to support menu tags on the right side and new layout from Advertising.
 *
 *    2025-02-10 (1.2.0) (jhoward)
 *      - Add <menu-schedules> to the <menu-item-highlighted-box> component if in admin view.
 *      - Add scheduling support to the <menu-item-highlighted-box> component.
 *
 *    2025-04-08 (1.3.0) (jhoward)
 *      - Remove "visual_" prefix from class names in <MenuItemHighlightedBox>.
 *      - Use <menu-item-price> in <MenuItemHighlightedBox>.
 */

import MenuTag from "../menu-tag.vue";
import {defineComponent, PropType} from "vue";
import {MenuItem} from "../defs";
import {computedIsScheduled} from "../../../helpers/menu-sections";
import MenuSchedules from "../schedule/MenuSchedules.vue";
import MenuItemPrice from "./MenuItemPrice.vue";

export default defineComponent({
  name: 'MenuItemHighlightedBox',
  components: {
    MenuItemPrice,
    MenuSchedules,
    MenuTag
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
  },
  computed: {
    isScheduled: computedIsScheduled,
  }
})
